import { ValidatorFn, ValidationErrors, FormGroup } from "@angular/forms";
import { COUNTRIES_WITH_STATES } from "../../constants";

export function CountryStateCrossRequired(countryFormControlName: string, stateFormControlName: string, validatorKey: string): ValidatorFn {

    return (formGroup: FormGroup): ValidationErrors | null => {
      let result: ValidationErrors = null;
      if (COUNTRIES_WITH_STATES.includes(formGroup.get(countryFormControlName).value)) {
        if (!formGroup.get(stateFormControlName).value || formGroup.get(stateFormControlName).value.length === 0) {
          result = {};
          result[validatorKey] = 'fieldValidation.required' ;
        }
      }
      return result;
    };
  
  }
  